export const ASN_DATA_LIST = 'ASN_DATA_LIST';
export const ASN_DATA_LIST_SUCCESS = 'ASN_DATA_LIST_SUCCESS';
export const ASN_DATA_LIST_ERROR = 'ASN_DATA_LIST_ERROR';

export const ASN_DATA_DETAILS = 'ASN_DATA_DETAILS';
export const ASN_DATA_DETAILS_SUCCESS = 'ASN_DATA_DETAILS_SUCCESS';
export const ASN_DATA_DETAILS_ERROR = 'ASN_DATA_DETAILS_ERROR';

export const ADD_ASN_DATA_DETAILS = 'ADD_ASN_DATA_DETAILS';
export const ADD_ASN_DATA_DETAILS_SUCCESS = 'ADD_ASN_DATA_DETAILS_SUCCESS';
export const ADD_ASN_DATA_DETAILS_ERROR = 'ADD_ASN_DATA_DETAILS_ERROR';

export const UPDATE_ASN_DATA = 'UPDATE_ASN_DATA';
export const UPDATE_ASN_DATA_SUCCESS = 'UPDATE_ASN_DATA_SUCCESS';
export const UPDATE_ASN_DATA_ERROR = 'UPDATE_ASN_DATA_ERROR';

export const DELETE_ASN_DATA = 'DELETE_ASN_DATA';
export const DELETE_ASN_DATA_SUCCESS = 'DELETE_ASN_DATA_SUCCESS';
export const DELETE_ASN_DATA_ERROR = 'DELETE_ASN_DATA_ERROR';